import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { levelLabel } from "@/lib/levels";
import { Button } from "@/components/ui/button";
import { Users, ArrowLeft, Play } from "lucide-react";

export default function MyRosters() {
  const [classes, setClasses] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    api.get("/director/my-classes")
      .then(({ data }) => setClasses(data))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="my-rosters-page">
      <Link to="/director" className="inline-flex items-center gap-1 text-sm font-semibold text-[#920e12] mb-6"><ArrowLeft size={16} /> Back to console</Link>
      <span className="text-xs uppercase tracking-[0.22em] font-extrabold text-[#920e12]">Director Console</span>
      <h1 className="mt-2 font-display text-4xl text-[#550001]">My classes &amp; rosters</h1>
      <p className="mt-2 text-[#545454]">Classes an admin has assigned to you. Open a roster to see participants, photo-release status, and take attendance.</p>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 gap-5">
        {classes.map((c) => (
          <div key={c.id} data-testid={`my-class-${c.id}`}
            className="bg-white rounded-2xl border border-[#dfd8da] p-6 hover:border-[#920e12] transition-colors duration-150">
            <div className="text-[10px] uppercase tracking-widest font-extrabold text-[#920e12]">
              {levelLabel(c.level)} · Session {c.session_no} · Class {c.class_no}
            </div>
            <h2 className="mt-1 text-lg font-bold text-[#1a1617]">{c.title || "Untitled class"}</h2>
            <p className="mt-1 text-sm text-[#545454]">{c.enrolled_count} participant{c.enrolled_count === 1 ? "" : "s"} enrolled</p>
            <div className="mt-4 flex gap-2">
              <Button asChild size="sm" className="flex-1 bg-[#920e12] hover:bg-[#550001] text-white" data-testid={`my-roster-open-${c.id}`}>
                <Link to={`/director/roster/${c.id}`}><Users size={15} className="mr-1" /> View roster</Link>
              </Button>
              <Button asChild size="sm" variant="outline" className="border-[#920e12] text-[#920e12]" data-testid={`my-run-${c.id}`}>
                <Link to={`/director/run/${c.id}`}><Play size={15} /></Link>
              </Button>
            </div>
          </div>
        ))}
      </div>

      {loaded && classes.length === 0 && (
        <div className="mt-10 bg-[#fff7f7] border border-[#f3c6c8] rounded-2xl p-6 text-[#545454]" data-testid="my-rosters-empty">
          No classes are assigned to you yet. An admin can assign you to a class from the Admin console, and it will appear here.
        </div>
      )}
    </div>
  );
}
